<template>
  <section class="pb-0">
    <div class="container" v-for="(el, i) in items" :key="i">
      <h6 class="text-ptn-color-gsj-5 pb-2">
        {{ formateoFecha(el.publish_up) }}
      </h6>
      <h2 class="pb-2">
        {{ el.title }}
      </h2>
      <div v-html="el.resumen" v-if="el.resumen != ''"></div>
      <h5>Organismo: {{ el.organismo }}</h5>
    </div>
  </section>
</template>

<script>
const axios = require("axios");
export default {
  name: "DetalleResidenciaComponent",
  props: {
    titulo: String,
    subtitulo: String,
    filtros: Object,
    data: Object,
    iconosGrandes: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hash: "DRC",
      items: null,
      title: null,
      desc: null,
    };
  },
  methods: {
    formateoFecha(fecha) {
      const fechaFormateado = fecha.split("T")[0];
      return fechaFormateado;
    },
  },
  mounted() {
    if (this.data == null) {
      let params = {};
      if (this.filtros != null && this.filtros != "") {
        params = this.filtros;
      }
      params.tipo = this.hash;
      axios
        .post(process.env.VUE_APP_API_URL, params)
        .then((response) => {
          this.items = response.data ? response.data.items : null;
          this.title = response.data ? response.data.title : null;
          this.desc = response.data ? response.data.desc : null;
          localStorage.setItem(this.hash, JSON.stringify(response));
        })
        .catch((error) => {
          if (!error.response) {
            console.log("Fuera de Linea");
            if (localStorage.getItem(this.hash)) {
              console.log("Cargando elementos de cache para " + this.hash);
              var resp = JSON.parse(localStorage.getItem(this.hash));
              this.items = resp.data ? resp.data.items : null;
              this.title = resp.data ? resp.data.title : null;
              this.desc = resp.data ? resp.data.desc : null;
            }
          }
        });
    } else {
      this.items = this.data;
    }
  },
};
</script>
